import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as allocations from '../../allocations'

export const RESOURCE = {
  payload: {
    description:
      'Represents the assignment of an employee to a project for a specific time period, detailing the percentage of their time allocated to that project.',
    dimension: allocations.RESOURCE.payload,
    level: 0,
    name: 'Allocation',
    partialId: PartialId.Standard.create('allocation'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
